// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Input } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import Page from 'app/ui/pages/Page';
import ClientModal from 'app/ui/modal/ClientModal';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
import PopupClient from './PopupClient';
// lib
import t from 'app/lib/i18n';
// actions
import { openSave, openUpdate, TYPE } from 'app/redux/actions/modal';
import { list, updateStatus, search, reset } from 'app/redux/actions/client';
// consts
import { STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
// css
import './Clients.scss';

class Clients extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.client.filter.term,
        };
    }

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    componentDidMount = () => this.props.dispatch(list());

    componentWillUnmount = () => this.props.dispatch(reset());

    onClickAdd = () => this.props.dispatch(openSave(TYPE.CLIENT));

    onClickEdit = client => this.props.dispatch(openUpdate(TYPE.CLIENT, client));

    onClickEnable = client => this.props.dispatch(updateStatus(client.id, { oldStatus: client.status, status: CLIENT_STATUS.ENABLED }));

    onClickDisable = client => this.props.dispatch(updateStatus(client.id, { status: CLIENT_STATUS.DISABLED }));

    renderEmpty = () => <EmptyList emptyMessage="Nenhum cliente encontrado." />;

    renderTable(data) {
        return (
            <Table id="list-clients">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={1}>Código</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Nome</Table.HeaderCell>
                        <Table.HeaderCell width={2}>CNPJ</Table.HeaderCell>
                        <Table.HeaderCell width={1}>Tipo</Table.HeaderCell>
                        <Table.HeaderCell width={1}>Status</Table.HeaderCell>
                        <Table.HeaderCell width={1} />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(data, row => {
                        const { id, name, cnpj, type, status } = row;
                        return (
                            <Table.Row key={id}>
                                <Table.Cell width="1">{id}</Table.Cell>
                                <Table.Cell width="10" className="wrap">
                                    {name}
                                </Table.Cell>
                                <Table.Cell width="2">{cnpj}</Table.Cell>
                                <Table.Cell width="1">{t(`client_type_${type}`)}</Table.Cell>
                                <Table.Cell className={`client_status_${status}`} width="1">
                                    {t(`client_status_${status}`)}
                                </Table.Cell>
                                <Table.Cell textAlign="right" width="1">
                                    <PopupClient
                                        client={row}
                                        onClickEdit={this.onClickEdit}
                                        onClickEnable={this.onClickEnable}
                                        onClickDisable={this.onClickDisable}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }
    render() {
        const { filter, loading } = this.props.client;
        return (
            <Page id="page-clients" loading={loading}>
                <div className="page-header">
                    <div className="page-title">CLIENTES</div>
                    <Button content="Adicionar" onClick={this.onClickAdd} />
                </div>
                <div className="body">
                    <div className="body-header">
                        <Input id="client-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : this.renderTable(filter.data)}
                </div>
                <ClientModal />
            </Page>
        );
    }
}

Clients.propTypes = {
    client: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    client: state.client,
});
export default connect(mapStateToProps)(Clients);
